import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';
import useFieldFormError from 'lib/form/useFieldFormError';
import { DateTime } from 'luxon';
import { FieldValues, RegisterOptions, useController } from 'react-hook-form';

import FormField, { FormFieldProps } from '../FormField';
import useDateValue from './useDateValue';

type CustomDatePickerProps = Omit<DatePickerProps<DateTime>, 'onChange' | 'value' | 'defaultValue' | 'name'>;
export interface FormDateFieldProps extends FormFieldProps, CustomDatePickerProps {
  rules?: Omit<RegisterOptions<FieldValues, string>, 'disabled' | 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>
  size?: 'small' | 'medium';
}

function FormDateField(props: FormDateFieldProps) {
  const {
    fieldDescription,
    labelId,
    name,
    required,
    rules,
    size = 'small',
    ...datePickerProps
  } = props;

  const { field } = useController({ name, rules: { required, ...rules } });
  const fieldError = useFieldFormError(name);
  const dateValue = useDateValue(field.value);

  return (
    <FormField
      name={name}
      labelId={labelId}
      required={required}
      fieldDescription={fieldDescription}
    >
      <DatePicker
        onChange={field.onChange}
        value={dateValue}
        closeOnSelect={false}
        slotProps={{
          textField: {
            size,
            error: Boolean(fieldError),
            fullWidth: true,
          },
        }}
        {...datePickerProps}
      />
    </FormField>
  );
}

export default FormDateField;
